export function getLegalAgeNumber(siteDetails, locationData) {
  // 1. Explicit site configuration property if provided by backend API
  const explicitAge = Number(
    siteDetails?.minimumAge ?? siteDetails?.minAge ?? siteDetails?.legalAge ?? siteDetails?.minimum_age
  );
  if (explicitAge === 18 || explicitAge === 19 || explicitAge === 21) {
    return explicitAge;
  }

  // 2. Province / State code from siteDetails or detected visitor location
  const provinceCode = String(
    siteDetails?.provinceCode ||
    siteDetails?.province ||
    siteDetails?.state ||
    locationData?.regionCode ||
    ''
  ).toUpperCase();

  // Canadian provinces where legal gambling age is 18 (Alberta, Manitoba, Quebec)
  if (['AB', 'MB', 'QC'].includes(provinceCode)) {
    return 18;
  }

  // Check jurisdiction string fallback
  const jurisdiction = String(siteDetails?.jurisdiction || '').toLowerCase();
  if (jurisdiction.includes('alberta') || jurisdiction.includes('manitoba') || jurisdiction.includes('quebec')) {
    return 18;
  }

  // Default for Canadian organizations (ON, BC, SK, NB, NS, PE, NL, etc.) is 19+
  return 19;
}

export function getLegalMinimumAgeLabel(siteDetails, locationData) {
  return `${getLegalAgeNumber(siteDetails, locationData)}+`;
}

export function interpolateLegalAge(text, age) {
  return String(text || '')
    .replaceAll('{{minAge}}', String(age))
    .replace(/\b18\+/g, `${age}+`)
    .replace(/\b18\b(?=\s*(?:or older|years|ans|años|\+))/gi, String(age))
    .replace(/(must be|devez avoir|debes tener)\s+18\b/gi, `$1 ${age}`);
}
